import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/LOGO LIP.svg'


const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = { class: "cont" }
const _hoisted_3 = {
  class: "row",
  style: {"min-height":"inherit"}
}
const _hoisted_4 = { class: "main bg-light" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "py-3 py-md-5" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row justify-content-center" }
const _hoisted_10 = { class: "col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4" }
const _hoisted_11 = { class: "card border border-light-subtle rounded-3 shadow-sm" }
const _hoisted_12 = { class: "card-body p-3 p-md-4 p-xl-5" }
const _hoisted_13 = { class: "row gy-2 overflow-hidden" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "form-floating mb-3" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "form-floating mb-3" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "d-flex gap-2 justify-content-between" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = {
  key: 0,
  class: "col-12"
}
const _hoisted_22 = { class: "footer bg-light pb-3" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = { class: "py-3 py-md-5" }
const _hoisted_26 = { class: "container" }
const _hoisted_27 = { class: "row justify-content-center" }
const _hoisted_28 = { class: "col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4" }
const _hoisted_29 = { class: "card border-0 bg-transparent" }
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = { class: "d-grid my-2 px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "spinner" }, null, -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("header", { class: "header bg-light" }, null, -1)),
        _createElementVNode("main", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("section", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-center mb-3" }, [
                            _createElementVNode("a", { href: "#!" }, [
                              _createElementVNode("img", {
                                src: _imports_0,
                                alt: "LOGO",
                                width: "80",
                                height: "80"
                              })
                            ])
                          ], -1)),
                          _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "fs-6 fw-normal text-center text-secondary mb-4" }, " Вход в личный кабинет ", -1)),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_FloatLabel, { variant: "on" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_InputMask, {
                                      id: "uid",
                                      class: "w-100 text-center",
                                      size: "large",
                                      modelValue: _ctx.uid,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uid) = $event)),
                                      mask: "999-999"
                                    }, null, 8, ["modelValue"]),
                                    _cache[4] || (_cache[4] = _createElementVNode("label", { for: "uid" }, "Введите UID", -1))
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_FloatLabel, { variant: "on" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_IconField, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_InputMask, {
                                          id: "birthdate",
                                          class: "w-100 text-center",
                                          size: "large",
                                          modelValue: _ctx.birthdate,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.birthdate) = $event)),
                                          mask: "99.99.9999",
                                          autocomplete: "off"
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_InputIcon, { class: "pi pi-calendar" })
                                      ]),
                                      _: 1
                                    }),
                                    _cache[5] || (_cache[5] = _createElementVNode("label", { for: "birthdate" }, "Дата рождения [дд.мм.гггг]", -1))
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_component_Checkbox, {
                                    modelValue: _ctx.pizza,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pizza) = $event)),
                                    inputId: "ingredient1",
                                    name: "pizza",
                                    value: "Cheese",
                                    class: "me-2 ml-0 pl-0"
                                  }, null, 8, ["modelValue"]),
                                  _cache[6] || (_cache[6] = _createElementVNode("label", {
                                    class: "form-check-label text-secondary",
                                    for: "ingredient1"
                                  }, " Запомнить ", -1))
                                ]),
                                _createVNode(_component_Button, {
                                  label: "Напомнить UID?",
                                  variant: "link",
                                  severity: "success",
                                  class: "py-0"
                                })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_Message, {
                      severity: "error",
                      class: "mt-3 mx-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("footer", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("section", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_Button, {
                          label: "Войти",
                          style: {"background-color":"#4caf50"},
                          rounded: "",
                          raised: "",
                          onClick: _ctx.handleSignIn
                        }, null, 8, ["onClick"]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_Button, {
                              label: "Регистрация",
                              severity: "info",
                              onClick: _ctx.navigateToRegister,
                              variant: "text"
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}